/**
 * Utilidades puras compartidas para la subida de ficheros (UploadArea y consumidores).
 */

export function formatFileSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

export function getFileIconType(fileName: string): string {
  const ext = fileName.split('.').pop()?.toLowerCase() ?? '';
  if (ext === 'pdf') return 'file-pdf';
  if (['jpg', 'jpeg', 'png', 'gif', 'webp', 'svg'].includes(ext)) return 'file-image';
  if (['mp4', 'webm', 'mov', 'ogv'].includes(ext)) return 'file-video';
  if (['mp3', 'wav', 'ogg', 'aac'].includes(ext)) return 'file-audio';
  if (['doc', 'docx'].includes(ext)) return 'file-doc';
  return 'file-document';
}
